import React from 'react'
import Home_S4_bg from '../../../img/Home_S4_bg.jpg'

const S4_Home = () => {
  return (
    <div className='S4_home'>
        <div className="container">
            <h3>Apple Watch  <br /> Series 8</h3>     
            <p>Limited Weekly Deals <span>$390.00</span></p>  
            <a className='button_class' href="#"> Shop Now </a>      
        </div>
    </div>
  )
}

export default S4_Home